import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useLocation, useHistory } from "react-router-dom"
import Cookies from "js-cookie"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import MainSectionHeader from "../common/MainSectionHeader"
import OptionsMenu from "./OptionsMenu"
import "../../App.css"
import { fetchLogin, fetchToken } from "../../lib/loginApi"
import { setAuthAccount } from "../../actions/loginActions"

const useStyles = makeStyles(theme => ({
  loginContainer:{
    marginTop: theme.spacing(2),
    justifyContent: "center"
  },
  loginMenu: {
    margin: theme.spacing(2),
    justifyContent: "center",
    display: "inline-flex"
  },
  inputs: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  loginButtons: {
    justifyContent: "center"
  },
  inputFields: {
    width: "60vw"
  },
  // eslint-disable-next-line no-useless-computed-key
  ["@media (min-height:700px)"]: {
    inputFields: {
      width: "30vw"
    },
  },
  messages: {
    color: "red",
    marginBottom: theme.spacing(),
  }
}))

const menuMapping = {
  0: "Login",
  // 1: "Sign Up",
  // 2: "Forgot Password",
}

const LoginScreen = (props) => {
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const { authenticated, account, dispatch } = props

  const [username, setUsername] = useState(null)
  const [password, setPassword] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [menuOption, setMenuOption] = React.useState(0)

  const handleMenuChange = (event, newValue) => {
    setMenuOption(newValue)
  }

  const handleUsername = (event) => {
    setErrorMessage(null)
    setUsername(event.target.value)
  }

  const handlePassword = (event) => {
    setErrorMessage(null)
    setPassword(event.target.value)
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleSubmit = () => {
    switch (menuMapping[menuOption]) {
      case "Login":
        handleLoginSubmit()
        break
      default:
        handleLoginSubmit()
    }
  }

  const handleLoginSubmit = async () => {
    try {
      const authResponse = await fetchLogin(username, password)
      if (authResponse.username) {
        dispatch(setAuthAccount(authResponse))
        Cookies.set(process.env.REACT_APP_APIKEY_COOKIE_NAME, authResponse.apiKey, { expires: 2 })
        handleTokenFetch()
      } else {
        if (authResponse.error && authResponse.error) {
          setErrorMessage(authResponse.error.message)
        } else {
          setErrorMessage("An unknown error occurred.")
        }
      }
    } catch (e) {
      setErrorMessage("Cannot connect to authentication server. Please try again.")
    }
  }

  const handleTokenFetch = async () => {
    try {
      const tokenReponse = await fetchToken(username, password)
      if (tokenReponse.response.token) {
        Cookies.set(process.env.REACT_APP_TOKEN_COOKIE_NAME, tokenReponse.response.token, { expires: 2 })
      }
    } catch (e) {
      setErrorMessage("Cannot connect to token server. Please try again.")
    }
  }

  useEffect(() => {
    if (authenticated && account) {
      let goTo
      try {
        goTo = location.state.referrer || "/"
      } catch (e) {
        goTo = "/"
      }
      history.push(goTo)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, account, location])

  return (
    <div className="App">
      <Container maxWidth="lg">
        <MainSectionHeader />
        <div className={classes.loginContainer}>
          <OptionsMenu handleChange={handleMenuChange} option={menuOption} classes={classes} />
          {errorMessage &&
            <div className={classes.messages}>
              <Typography variant={"body1"} gutterBottom>{errorMessage}</Typography>
            </div>
          }
          <div className={classes.inputs}>
            <Typography gutterBottom>Username</Typography>
            <TextField
              className={classes.inputFields}
              id="standard-outline-username"
              style={{ marginLeft: "10px" }}
              type="string"
              placeholder="Username"
              InputLabelProps={{
                shrink: true,
              }}
              variant={"outlined"}
              onChange={handleUsername}
            />
          </div>
          {menuMapping[menuOption] !== "Forgot Password" ?
            (<div className={classes.inputs}>
              <Typography gutterBottom>Password</Typography>
              <TextField
                className={classes.inputFields}
                id="standard-outline-password"
                style={{ marginLeft: "10px" }}
                type={showPassword ? "text" : "password"}
                variant={"outlined"}
                onChange={handlePassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>)
            :
            (<>
              <Typography gutterBottom variant="caption" display="block">
                Enter your username and you will be sent a reset password prompt
              </Typography>
            </>)}
          <Button
            disabled={!username && !password}
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
          >
            {menuMapping[menuOption]}
          </Button>
        </div>
      </Container>
    </div>
  )
}


const mapStateToProps = (state) => ({
  authenticated: state.authenticated || false,
  account: state.account || null,
})

export default connect(mapStateToProps)(LoginScreen)

